import { translateFn } from '../../../../../../../../../../utils/translator.helper';
import { DefaultColumnKeys, IColumnType, IDataTableColumn } from '../../../../../../../../../../ui/gzDataTable/types';
import { RequiredValidator } from '../../../../../../../../../../ui/gzForm/validators/required.validator';
import { CustomizableValidator } from '../../../../../../../../../../ui/gzForm/validators/customizable.validator';
import { universalAbsolutePath } from '../../../../../../../../../common/policyPanel/uiSettings/utils/validators/path.validators';
import { MaxLengthValidator } from '../../../../../../../../../../ui/gzForm/validators/max-length.validator';
import { MAX_TASK_PATH_LENGTH } from '../../../../../../../utils/uiSettings/antimalware/antimalware.values';

export enum ColumnKeys {
  PATH = 'path',
}

export function getTableColumns(): IDataTableColumn[] {
  return [
    {
      key: ColumnKeys.PATH,
      header: translateFn('Files and folders to scan'),
      columnType: IColumnType.TEXT,
      editable: true,
      validators: [
        RequiredValidator(translateFn('Required field')),
        MaxLengthValidator(
          MAX_TASK_PATH_LENGTH,
          translateFn('The path must not exceed {maxLength} characters.', {
            maxLength: MAX_TASK_PATH_LENGTH,
          })
        ),
        CustomizableValidator((value: string) => universalAbsolutePath(value, ['All Local Drives'])),
      ],
    },
    {
      key: DefaultColumnKeys.ACTIONS,
      header: translateFn('Actions'),
      columnType: IColumnType.DISPLAY,
    },
  ];
}
